import axiosPrivate from "@services/axiosPrivate"

const getTimeZoneDeltaUTC = async (adAccountId) => {
  const response = await axiosPrivate.get(`act_${adAccountId}/`, {
    params: {
      fields:
        "timezone_id,timezone_offset_hours_utc,timezone_name"
    },
  })
  return response.data
}

export default getTimeZoneDeltaUTC;